import Breadcrumb from './breadcrumb'
import BreadcrumbItem from './breadcrumb-item'
import './breadcrumb.less'

Breadcrumb.install = function (Vue, options = {}) {
  const name = options.name || Breadcrumb.name
  Vue.component(name, Breadcrumb)
  Vue.component(name + '-item', BreadcrumbItem)
}

export const MBreadcrumb = Breadcrumb
export const MBreadcrumbItem = BreadcrumbItem

export default Breadcrumb
